import { Signal, WritableSignal } from '@angular/core';

export type SignalBased<T> = {
  [K in keyof T]: WritableSignal<T[K]> | Signal<T[K]>;
};

export type WritableSignalBased<T> = {
  [K in keyof T]: WritableSignal<T[K]>;
};
